import React from 'react';
import Star from './Star';

const Rating = ({ rating, maxRating = 5, size = 24 }) => {
  const stars = [];
  for (let i = 0; i < maxRating; i++) {
    let fill = 0;
    if (i < Math.floor(rating)) {
      fill = 1;
    } else if (i === Math.floor(rating)) {
      fill = rating - Math.floor(rating);
    }
    stars.push(<Star key={i} fill={fill} size={size} />);
  }
  return <div className="rating" title={rating}>{stars}</div>;
};

export default Rating;
